module.exports = __webpack_public_path__ + "static/img/COC2023-12.8303384.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-12.png
// module id = TsIY
// module chunks = 0